import { RootState } from "../rootReducer"

export const selectApplicationTemplates = (state: RootState) => state.workshop.applicationTemplates
export const selectApplicationTemplatesMap = (state: RootState) => state.workshop.applicationTemplatesMap
export const selectCurrentApplicationTemplateId = (state: RootState) => state.workshop.currentApplicationTemplate?.Id
export const selectCurrentApplicationTemplateVersionId = (state: RootState) =>
    state.workshop.currentApplicationTemplateVersionId
export const selectCurrentApplicationTemplate = (state: RootState) => state.workshop.currentApplicationTemplate
export const selectCurrentApplicationTemplateVersion = (state: RootState) =>
    state.workshop.currentApplicationTemplateVersion
export const selectIsCreatingApplicationTemplate = (state: RootState) => state.workshop.isApplicationTemplateCreating
export const selectIsApplicationTemplatesExist = (state: RootState) => state.workshop.isApplicationTemplatesExist
export const selectPublishedApplicationTemplates = (state: RootState) => state.workshop.publishedTemplates
export const selectWorkshopQueryString = (state: RootState) => state.workshop.queryString
export const selectWorkshopEditMode = (state: RootState) => state.workshop.isEditMode
export const selectWorkshopCatalog = (state: RootState) => state.workshop.workshopCatalog
export const selectReleasedApplications = (state: RootState) => state.workshop.releasedApplications
export const selectActualVersion = (state: RootState, applicationId = "") =>
    state.workshop.actualVersions[applicationId]
export const selectActualVersions = (state: RootState) => state.workshop.actualVersions
